/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import LineChartComponent from './../Components/LineChartComponent.jsx';
import {
  getArtifactTimingMetrics,
  getMetricsPageHighlights,
} from './../reducers';
import { selectJob } from './../actions';
import { metricsJobIdTooltipFooter } from './../helpers/chart';
import PropTypes from 'prop-types';

const colorMap = {
  'TotalWorkerThreadDequeueTime' : 'rgba(66, 244, 212, 1)'
};

const getSeries = (timingNames, length) => {
  const pointRadius = length ? 0 : 4;
  return timingNames.map(n => {
    return {
      label: n,
      pointRadius: pointRadius,
      pointBackgroundColor: colorMap[n],
      backgroundColor: colorMap[n],
      pointBorderColor: colorMap[n],
      fill: true
    };
  });
};

const getData = (sortedNames, timings) =>
  sortedNames.map(n =>
    timings.map(t =>
      t && t[n] > 0 ?
        t[n] :
        null
    )
  );

export const mapStateToProps = (state, ownProps) => {
  const metrics = getArtifactTimingMetrics(state);
  const timings = (ownProps.isCcf) ?
    metrics.map(m => m ? m.ccfTiming : m) :
    metrics.map(m => m ? m.ncfTiming : m);

  const timingNamesHash = {};
  if (timings && timings.length > 0)
  {
    timings.filter(t => t !== undefined)
      .forEach(t => Object.keys(t).forEach(k => timingNamesHash[k] = k));
  }
  const sortedTimingNames = Object.keys(timingNamesHash).sort();
  const highlights = getMetricsPageHighlights(state);
  return {
    stacked: ownProps.stacked,
    data: getData(sortedTimingNames, timings).filter(d => d),
    series: getSeries(sortedTimingNames, metrics.length),
    labels: metrics.map(m => m ? m.jobNumber : m),
    lines: highlights,
    options: {
      legend: { display: false },
      scales: { xAxes: [{ offset: true }] },
      tooltips: {
        callbacks: {
          footer: (tooltipItem) => metricsJobIdTooltipFooter(tooltipItem)(metrics)
        }
      }
    }
  };
};

const WorkerThreadTimingChartContainer = connect(
  mapStateToProps,
  { onClick: selectJob }
)(LineChartComponent);

WorkerThreadTimingChartContainer.propTypes = {
  stacked: PropTypes.bool.isRequired,
  data: PropTypes.array,
  series: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    pointRadius: PropTypes.number.isRequired,
    pointBackgroundColor: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
    pointBorderColor: PropTypes.string.isRequired,
    fill: PropTypes.bool.isRequired
  })),
  labels: PropTypes.array,
  lines: PropTypes.arrayOf(PropTypes.shape({
    xAxisValues: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired
  })),
  options: PropTypes.shape({
    legend: PropTypes.object.isRequired,
    scales: PropTypes.object.isRequired,
    toolTips: PropTypes.shape({
      callbacks: PropTypes.shape({
        footer: PropTypes.func
      })
    })
  })
};

export default WorkerThreadTimingChartContainer;


// WEBPACK FOOTER //
// src/Containers/WorkerThreadTimingChartContainer.jsx